import { render } from "./PanelOperativo.vue?vue&type=template&id=651ced70&scoped=true"
import script from "./PanelOperativo.vue?vue&type=script&lang=js"
export * from "./PanelOperativo.vue?vue&type=script&lang=js"

import "./PanelOperativo.vue?vue&type=style&index=0&id=651ced70&scoped=true&lang=scss"

import exportComponent from "D:\\Proyectos\\SewayERP\\front-erpseway\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651ced70"]])

export default __exports__